export default __webpack_public_path__ + "static/media/icons8-file-96.e3dc7de8.svg";